import styled from 'styled-components';
export var CleaningIncludedTag = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-3d54g4-0"
})(["padding:", ";border-radius:4px;font-size:", ";line-height:", ";color:", ";background-color:", ";"], function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.colors.lightest;
}, function (props) {
  return props.theme.colors.emerald;
});
export var OtherFeeDescriptionWrapper = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-3d54g4-1"
})(["display:flex;flex-direction:column;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2, 'column');
});
export var NoteFromLandlordWrapper = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-3d54g4-2"
})(["display:flex;flex-direction:column;", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.gap(1, 'column');
});
export var NoteFromLandlordContent = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-3d54g4-3"
})(["color:", ";"], function (props) {
  return props.theme.colors.cornFlowerBlue;
});
export var CleaningFeeLabels = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-3d54g4-4"
})(["display:flex;flex-direction:row;flex-wrap:wrap;column-gap:", ";"], function (props) {
  return props.theme.space(1);
});
export var SelectDatesToSee = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-3d54g4-5"
})(["cursor:pointer;color:", ";"], function (props) {
  return props.theme.colors.uniBlue;
});